// Campos ainda não existem no contrato de RegionalHub.
// Ver services/cidades.js antes de trocar mocks por dados da API.
export const MOCK_QUEM_MANTEM_TEXTO = "";

export const MOCK_HISTORIA_FALLBACK = "";

export const MOCK_COMO_AJUDAR_TEXTO = "";

export const MOCK_PARCEIROS = [
  { name: "Prefeitura Municipal" },
  { name: "Instituto ProSer" },
];

export const MOCK_EQUIPE = Array.from({ length: 8 }, (_, i) => ({
  name: `Colaborador(a) ${i + 1}`,
  role: "Equipe do núcleo",
}));

// O modelo RegionalHub ainda não possui campo de UF.
export const ESTADO_FALLBACK = "Minas Gerais";
